import {
    ADD_ITEM_REQUEST,
    ADD_ITEM_SUCCESS,
    ADD_ITEM_FAILURE,
    ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR,
    UNSELECT_PRODUCT,
    UPDATE_SELECTED_PRODUCT,
    MODAL_RESET_ERROR,
    MODAL_CLOSED,
} from '../constants';
import { pdpConstants } from '@ynap/product-details-state';

const { CHANGE_SELECTED_SKU } = pdpConstants;

const initialState = {
    loading: false,
    error: null,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case ADD_ITEM_REQUEST:
            return {
                ...state,
                error: null,
                loading: true,
            };

        case ADD_ITEM_SUCCESS:
            return {
                ...state,
                response: {
                    body: action.body,
                },
                error: null,
                loading: false,
            };

        case ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR:
        case ADD_ITEM_FAILURE:
            return {
                ...state,
                error: action.body
                    ? {
                          body: action.body,
                          headers: action.headers, // TODO: White list headers
                          status: action.status,
                      }
                    : action.type,
                loading: false,
            };

        case MODAL_CLOSED:
            return {
                ...state,
                error: action.type,
                loading: false,
            };

        case MODAL_RESET_ERROR:
        case CHANGE_SELECTED_SKU:
        case UPDATE_SELECTED_PRODUCT:
        case UNSELECT_PRODUCT:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
}
